import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#F7941D" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/pages/Yoko%20Sushi%20&%20Noodle%20House/132479016781889/"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Yoko Sushi Yelp"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/yokosushi.surrey/"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Yoko Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#F7941D" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/pages/Yoko%20Sushi%20&%20Noodle%20House/132479016781889/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Yoko Sushi Yelp"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/yokosushi.surrey/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Yoko Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
